import { Button, Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react';
import { accountTypeOptions } from '@pelicargo/utils';
import { HiChevronLeft } from 'react-icons/hi';

import { RequestFilters } from '../../hooks/useRequestFilters';

const options = [{ label: 'All', value: 'All' }, ...accountTypeOptions];

type Props = {
  filters: RequestFilters;
  handleCheckboxFilterChange: (key: string) => (nextValue: string[]) => void;
  resetView: () => void;
};

export const AccountTypeFilter = ({ filters, handleCheckboxFilterChange, resetView }: Props) => (
  <Stack spacing="2" pt="2">
    <Stack direction="row" align="center" spacing="2">
      <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
        Account Type
      </Button>
    </Stack>

    <CheckboxGroup value={filters.account_type} onChange={handleCheckboxFilterChange('account_type')}>
      {accountTypeOptions?.map(({ label, value }) => (
        <Checkbox key={value} value={value}>
          {label}
        </Checkbox>
      ))}
    </CheckboxGroup>
  </Stack>
);
